import * as api from "../../../api/generated-api";
import React from "react";
import DKFormSelect from "../../common/forms/DKFormSelect";
import { SelectChangeEvent } from "@mui/material";

type DealLegalEntitySelectProps = {
  dataTestId: string;
  selectedDealLegalEntityId: number;
  dealLegalEntities: api.DealLegalEntity[];
  onChange: (event: SelectChangeEvent) => void;
};
export const DealLegalEntitySelect = (props: DealLegalEntitySelectProps) => {
  const {
    dataTestId,
    selectedDealLegalEntityId,
    dealLegalEntities = [],
    onChange,
  } = props;
  return (
    <DKFormSelect
      dataTestId={dataTestId}
      label={""}
      selectedValue={selectedDealLegalEntityId}
      items={dealLegalEntities.map((dealLegalEntity) => {
        return {
          value: dealLegalEntity.id,
          label: dealLegalEntity.name,
        };
      })}
      onChange={onChange}
    />
  );
};
